import * as React from 'react';

import { connect } from 'react-redux';

import Transcript from '../components/Transcript';

import {
  IAlignedWord,
  ITrack,
} from '../api';
import { TrackInfo } from '../components/TrackInfo';
import { playClip, selectTranscript } from '../thunks';
import { RootState } from '../types';

interface IOwnProps {
  trackID: string,
}

type IProps = {
  alignment: IAlignedWord[] | null,
  currentTime: number,
  error: Error | null,
  isSeeking: boolean,
  track: ITrack,
  transcript: string | null,

  onInit: (trackID: string) => any,
  onSeek: (id: string, t: number) => any,
} & IOwnProps

class TranscriptView extends React.Component<IProps> {

  public componentWillMount() {
    const {
      onInit,
      trackID,
    } = this.props;
    onInit(trackID);
  }

  public render() {
    const {
      alignment,
      currentTime,
      error,
      isSeeking,
      onSeek,
      track,
      transcript,
      trackID,
    } = this.props;

    let body = null;
    if (transcript) {
      body = (<Transcript
        trackID={ trackID }
        transcript={ transcript }
        alignment={ alignment || [] }
        isSeeking={ isSeeking }
        currentTime={ currentTime }
        onSeek={ onSeek } />);
    }
            
    return (<div className="container">
      <h3>{ trackID }</h3>
      <button onClick={this.onPlay}>PLAY</button>
      <TrackInfo track={track} />
      {body}
      {error ? 'Error: ' + error.message : ''}
    </div>);
  }

  private onPlay = () => {
    const {onSeek, trackID} = this.props;
    onSeek(trackID, 0);
  }

}

export const TranscriptContainer = connect(
  ({player, transcripts, tracks, router}: RootState, {trackID}: IOwnProps) => {
    const tran = transcripts.data[trackID] || null;
    const track = tracks.data[trackID] || null;
    const error = transcripts.status[trackID] ? transcripts.status[trackID].error : null;

    return {
      alignment: tran ? tran.alignment : null,
      currentTime: player.currentTime,
      error,
      isSeeking: player.isSeeking,
      track,
      transcript: tran ? tran.transcript : null,
    };
  },
  dispatch => ({
    onInit: (trackID: string) => { dispatch<any>(selectTranscript(trackID)) },
    onSeek: (recordingId: string, t: number) => dispatch<any>(playClip({
      recording_id: recordingId,
      start: t
    })),
  })
)(TranscriptView)

export default TranscriptContainer;



// WEBPACK FOOTER //
// ./src/pages/TranscriptPage.tsx